import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'

import { Layout, LayoutItem } from 'components/layout'
import { useEventType } from 'features/event_type_provider'

import { useCopyFrom } from './hooks'
import { SearchResults } from './search_results'
import { useSearchForEventTypesV4 } from './use_search_for_event_types'

export const CopyFromContent = ({ selectedETs, setSelectedETs, userId }) => {
  const { id } = useEventType()

  const [SearchInput, query, results, isLoading, fetchMore, isLoadingMore] = useSearchForEventTypesV4(
    { eventTypeId: id, userId }
  )

  const handleSelection = (et) => setSelectedETs([et])

  return (
    <>
      <LayoutItem paddingX="16">{SearchInput}</LayoutItem>
      <div>
        <SearchResults
          isLoading={isLoading}
          query={query}
          results={results}
          handleSelection={handleSelection}
          selectedETs={selectedETs}
          itemType="copy-from"
          fetchMore={fetchMore}
          isLoadingMore={isLoadingMore}
        />
      </div>
    </>
  )
}

const BodyLayout = (props) => <Layout direction="column" gap="12" {...props} />

export const CopyFromPopup = ({ onClose, selectedETs, toggleDropdown, userId }) => {
  const { copyFromEventType, isLoading } = useCopyFrom({ toggleDropdown, userId })
  const eventType = selectedETs[0]

  const handleConfirm = () => { copyFromEventType(eventType) }

  return (
    <SimplePopup
      cancelLabel={I18n.t('publisher.action.cancel')}
      confirmLabel={I18n.t('publisher.action.copy')}
      onClose={onClose}
      onConfirm={handleConfirm}
      isLoading={isLoading}
      title={I18n.t(
        'publisher.event_type_editor.sections.availability.schedule.actions.copy_from_to.from_popup_title',
        { name: eventType.name }
      )}
    >
      <BodyLayout>
        <p>{HtmlParser(I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.copy_from_to.from_popup_line_1'))}</p>
        <p>{I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.copy_from_to.from_popup_line_2')}</p>
      </BodyLayout>
    </SimplePopup>
  )
}
